<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

import {
  bgPrimary,
  borderSeparatorTransparency,
  useDeviceStore,
  useSearchStore,
} from '@nora-monorepo/ui-shared';

import ConversationList from '#nora-chat-ui/components/sidebar/conversation-list/ConversationList.vue';
import ConversationListHeader from '#nora-chat-ui/components/sidebar/conversation-list/ConversationListHeader.vue';
import SearchResults from '#nora-chat-ui/components/sidebar/search/SearchResults.vue';

const searchStore = useSearchStore();
const { isSearching } = storeToRefs(searchStore);
const deviceStore = useDeviceStore();
const { isMobile, isTablet, isDesktop, isExtraLargeDesktop }
  = storeToRefs(deviceStore);

const sidebarWidth = computed(() => {
  if (isMobile.value) {
    return 'w-full';
  }

  if (isTablet.value) {
    return 'min-w-[max(33%,320px)] w-1/3';
  }

  if (isDesktop.value) {
    return 'min-w-[max(25%,320px)] w-1/4';
  }

  if (isExtraLargeDesktop.value) {
    return 'min-w-[max(10%,320px)] max-w-[512px] w-1/10';
  }

  return 'w-full';
});

const showSearch = computed(() => {
  return isSearching.value;
});

const showConversations = computed(() => {
  return !showSearch.value;
});
</script>

<template>
  <div
    id="nora-chat-sidebar"
    class="flex flex-col border-r max-h-full overflow-hidden shrink-0" :class="[
      sidebarWidth,
      bgPrimary,
      borderSeparatorTransparency,
    ]"
  >
    <ConversationListHeader />
    <TransitionGroup name="conversation-list">
      <ConversationList v-if="showConversations" />
    </TransitionGroup>
    <transition
      name="fade"
      appear
    >
      <SearchResults v-if="showSearch" />
    </transition>
  </div>
</template>
